<template>
  <div id="app">
    <router-view></router-view>
    <modal-alert v-if="$store.getters.getIsShowModal" @close="closeModal" :message="$store.getters.getModalMessage" :modalWidth="$store.getters.getModalWidth"></modal-alert>
    <maintenance-modal v-if="$store.getters.getIsShowMaintenanceModal" :html="$store.getters.getMaintenanceExp"  @close="closeMaintenanceModal" />
    <verify-payment-modal v-if="$store.getters.getIsShowVerifyPaymentModal" />
  </div>
</template>

<script>
import ModalAlert from '@/components/ModalAlert'
import MaintenanceModal from '@/view/warehouses/MaintenanceModal'
import VerifyPaymentModal from '@/components/VerifyPaymentModal'

export default {
  name: 'App',
  components: {
    ModalAlert,
    MaintenanceModal,
    VerifyPaymentModal
  },
  methods: {
    /*
     * Close modal
     *
     * @return void
     */
    closeModal () {
      $('#myModal').modal('hide')
      this.$store.commit('toggleModal')
    },
    closeMaintenanceModal () {
      $('#maintenance-modal').modal('hide')
      this.$store.commit('toggleMaintenanceModal')
      if (this.$route.name !== 'Warehouses') {
        this.$router.push('/warehouses')
      }
    }
  }
}
</script>
<style>
.vld-overlay.is-full-page::after {
  content: "データ読み込み中…";
  position: inherit;
  margin-top: 100px;
  font-size: 16px;
  color: #333;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue